import { useCallback, useEffect, useState } from 'react';
import {
  IconLoader,
  ResponseError,
  responseErrorsResolver,
  InputText,
  ButtonPrimary,
} from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetPSPDetailsQuery,
  useEditPSPDetailsMutation,
} from './store/services/details';
import { PSPBrandKeys, PSPDetailsKeys } from './types';
import IconTopUp from '../../components/settings/details-form/images/top-up';

import cn from './styles.module.css';

const TopUpSettings = () => {
  const {
    settings: {
      details: { pspDetails },
    },
  } = useAppSelector((state) => state);
  const [editError, setEditError] = useState('');
  const [topUpName, setTopUpName] = useState('');

  const [getTopUpSettings, { isLoading }] = useLazyGetPSPDetailsQuery();
  const [edit, { isLoading: editIsLoading }] = useEditPSPDetailsMutation();

  const whiteLabel = pspDetails?.find(
    (item) => item.key === PSPBrandKeys.WHITELABEL,
  );

  const onSave = async () => {
    setEditError('');

    const response = (await edit({
      transactionsTopUpButtonName: topUpName,
      key: PSPDetailsKeys.TOP_UP,
    })) as { error?: ResponseError };

    if (response?.error) {
      responseErrorsResolver({
        errors: response?.error,
        setError: () => {},
        setGlobalError: setEditError,
      });
    }
  };

  const getTopUpSettingsAction = useCallback(async () => {
    const response = await getTopUpSettings();

    if (response && response.data) {
      const topUpSettings = response?.data?.data?.edges?.find(
        (item) => item?.node.key === PSPDetailsKeys.TOP_UP,
      );

      if (topUpSettings) {
        setTopUpName(topUpSettings?.node?.data?.value as string);
      }
    }
  }, []);

  useEffect(() => {
    if (!pspDetails) {
      getTopUpSettingsAction();
    } else {
      const topUpSettings = pspDetails?.find(
        (item) => item?.key === PSPDetailsKeys.TOP_UP,
      );

      if (topUpSettings) {
        setTopUpName(topUpSettings.data?.value as string);
      }
    }
  }, [pspDetails]);

  useEffect(() => {
    let title = 'Settings: Cards';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.cardsSettingsLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading) {
    content = (
      <div className={cn.topUpSettingsWrapper}>
        <InputText
          name="topUpName"
          value={topUpName}
          onChange={(e) => setTopUpName(e.target.value)}
          title="The name of the top-up button"
          placeholder="Enter top-up button name"
        />
        <div className={cn.topUpSettingPreview}>
          <div className={cn.topUpSettingsButton}>
            <div
              className={cn.iconWrapper}
              style={{
                background: (
                  whiteLabel?.data?.value as { brandPrimary: string }
                )?.brandPrimary,
              }}
            >
              <IconTopUp />
            </div>
            <span>{topUpName || 'Top Up'}</span>
          </div>
        </div>
        {editError && <div className={cn.cardsEditError}>{editError}</div>}
        <ButtonPrimary
          text={!editIsLoading ? 'Save' : 'Loading...'}
          onClick={onSave}
          disabled={editIsLoading}
          className={cn.saveButton}
          bold
        />
      </div>
    );
  }

  return <div className={cn.cardsSettingsWrapper}>{content}</div>;
};

export default TopUpSettings;
